import { g as a } from "./index767.mjs";
import { s as l } from "./index803.mjs";
import { h as i } from "./index811.mjs";
import { u as m } from "./index824.mjs";
import { s as S } from "./index825.mjs";
import { u as e } from "./index826.mjs";
var b = a, v = l, t = i, f = m, u = S, w = e, o = b.Symbol, s = v("wks"), y = w ? o.for || o : o && o.withoutSetter || f, O = function(r) {
  return t(s, r) || (s[r] = u && t(o, r) ? o[r] : y("Symbol." + r)), s[r];
};
export {
  O as w
};
